/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import cloneDeep from 'lodash/cloneDeep';
import cx from 'classnames';
import $ from 'jquery';
import FileSaver from 'file-saver';
import {
  Icon,
  Modal,
  Header,
  Loader,
} from 'semantic-ui-react';
import api from '../../api';
import DeleteModal from '../Modal/DeleteModal';
import ExportModal from '../Modal/ExportModal';
import {
  REPORT_EXTENSION_CSV,
  REPORT_EXTENSION_EXCEL,
  REPORT_EXTENSION_JSON,
} from '../../constants/reports';
import MoveFileModal from '../Modal/MoveFileModal';
import SPDXDocumentGenerator from '../SBOM/SPDXDocumentGenerator';
import CycloneDXDocumentGenerator from '../SBOM/CycloneDXDocumentGenerator';
import VexGenerator from '../SBOM/VexGenerator';
import NISModal from '../NISTools/NISModal';
import moreBtn from '../../images/components/content_project_card/newRisk.png';
import normalBookmarkImg from '../../images/components/content_projects_list/bookmarkBtn (Version) (normal).png';
import activeBookmarkImg from '../../images/components/content_projects_list/bookmarkBtn (Version) (active).png';
import compareBtn from '../../images/icons/compare.png';
import moveFileIcon from '../../images/components/content_project_card/move-file-icon.svg';
import deleteIcon from '../../images/components/content_project_card/delete-icon.svg';
import exportIcon from '../../images/components/content_project_card/export-icon.svg';
import quickScan from '../../images/components/content_project_card/quickScan.png';
import ScanInfoModal from '../Modal/ScanInfoModal';
import SecurityRiskUpdatedModal from '../Modal/SecurityRiskUpdatedModal';
import CBOMGenerator from '../SBOM/CBOMGenerator';

class SecurityProjectCard extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.modalHeader = null;
    this.modalSubBody = null;
    this.state = {
      isOpen: false,
      modalExportIsOpen: false,
      isDownloadingReport: false,
      isOpenMFM: false,
      isMovingFile: false,
      isOpenMSI: false,
      isOpenMSU: false,
      movingData: {},
      projectList: props.projectList,
      isSelectable: props.isSelectable,
      checkValues: props.checkValues,
      isOpenAlertModal: false,
      toExport: '',
      isOpenMCX: false,
      isOpenMCD: false,
      isOpenMNA: false,
      isShowSbom: false,
      isOpenMVX: false,
      activeMenuIndex: '',
      isOpenMCB: false,
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleExport = this.handleExport.bind(this);
    this.handleCardBookmarkChange = this.handleCardBookmarkChange.bind(this);
    this.handleCardVersionBookmarkChange = this.handleCardVersionBookmarkChange.bind(this);
    this.handleLeakageList = this.handleLeakageList.bind(this);
    this.closeExportModal = this.closeExportModal.bind(this);
    this.downloadReport = this.downloadReport.bind(this);
    this.deletedCallback = this.deletedCallback.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.closeMoveFileModal = this.closeMoveFileModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleInfoItem = this.handleInfoItem.bind(this);
    this.handleSecurityInfoItem = this.handleSecurityInfoItem.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleSpdx = this.handleSpdx.bind(this);
    this.handleCycloneDx = this.handleCycloneDx.bind(this);
    this.handleVexBom = this.handleVexBom.bind(this);
    this.handleNIASbom = this.handleNIASbom.bind(this);
    this.handleSlideToggle = this.handleSlideToggle.bind(this);
    this.handleMoreMenu = this.handleMoreMenu.bind(this);
    this.setFileMove = this.setFileMove.bind(this);
    this.setCompareItem = this.setCompareItem.bind(this);
    this.refreshSecurityReport = this.refreshSecurityReport.bind(this);
    this.handleCBOM = this.handleCBOM.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.content_project_card .name', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    const { isSelectable, checkValues } = this.props;
    if (prevProps.isSelectable !== isSelectable) {
      this.setState({
        isSelectable,
      });
    }

    if (prevProps.checkValues.length !== checkValues.length) {
      this.setState({
        checkValues,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleLeakageList = () => {
    const { uploaded_file_id, name } = this.props.file;
    this.props.handleLeakageList(uploaded_file_id, name);
  };

  handleInfoItem = () => {
    this.setState({
      isOpenMSI: true,
    });
  };

  handleSecurityInfoItem = () => {
    this.setState({
      isOpenMSU: true,
    });
  };

  handleClick = () => {
    const { file, clickEvent } = this.props;
    clickEvent(file.uploaded_file_id);
  };

  handleDelete = () => {
    this.setState({
      isOpen: true,
    });
  };

  handleExport = () => {
    this.setState({
      modalExportIsOpen: true,
    });
  };

  handleSpdx = () => {
    this.setState({
      isOpenMCX: true,
    });
  };

  handleCycloneDx = () => {
    this.setState({
      isOpenMCD: true,
    });
  };

  handleVexBom = () => {
    this.setState({
      isOpenMVX: true,
    });
  };

  handleNIASbom = () => {
    this.setState({
      isOpenMNA: true,
    });
  };

  handleClose() {
    this.setState({
      isOpen: false,
    });
  }

  handleCBOM() {
    const { file, translate } = this.props;
    const { has_crypto } = file;

    if (has_crypto) {
      this.setState({
        isOpenMCB: true,
      });
    } else {
      this.modalAction = translate('modal.title.notice');
      this.modalBody = translate('modal.message.no_crypto_data');
      this.modalHeader = null;

      this.setState({
        isOpenAlertModal: true,
      });
    }
  }

  handleCardVersionBookmarkChange = (e, pvid) => {
    const projectVersionId = pvid;
    api
      .toggleBookmark(
        {
          project_version_id: projectVersionId,
          view_point: 'security',
        }
      )
      .then((response) => {
        const res = response.response;
        this.props.handleCardVersionBookmarkChange(
          this.props.cardIndex,
          projectVersionId,
          res.is_bookmark
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleCardBookmarkChange = (e, ufid) => {
    api
      .toggleBookmark(
        {
          uploaded_file_id: ufid,
          view_point: 'security',
        }
      )
      .then((response) => {
        const res = response.response;
        this.props.handleCardBookmarkChange(this.props.cardIndex, ufid, res.is_bookmark);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleMove = () => {
    const { projectList } = this.state;
    const findProjectIndex = projectList.findIndex((item) => {
      return item.pid === this.props.file.project_id;
    });

    const findVersionGroup = projectList[findProjectIndex].upLoaded.filter((item) => {
      return item.project_version_id === this.props.file.project_version_id;
    });

    const rowData = {
      name: this.props.file.name,
      projectName: projectList[findProjectIndex].projectName,
      projectVersionName: findVersionGroup[0].project_version_name,
      uploaded_file_id: this.props.file.uploaded_file_id,
      project_id: this.props.file.project_id,
    };

    this.setState({
      isOpenMFM: true,
      movingData: rowData,
    });
  };

  handleCheckChange = (e) => {
    const { file, isSelectable } = this.props;
    if (!isSelectable || !file.has_manage_permission) {
      return;
    }
    this.props.handleCheckChange(e, { value: file.uploaded_file_id });
  };

  handleClickOutside = (event) => {
    const { activeMenuIndex } = this.state;
    const container = $('.content_project_card');
    if (container && container.has(event.target).length === 0) {
      if (activeMenuIndex !== '') {
        this.setState({
          isShowSbom: false,
          activeMenuIndex: '',
        });
      }
    }
  };

  handleSlideToggle = () => {
    const { isShowSbom } = this.state;
    this.setState({
      isShowSbom: !isShowSbom,
    });
  };

  handleMoreMenu = () => {
    const { file } = this.props;
    const { uploaded_file_id } = file;
    const { activeMenuIndex } = this.state;
    if (activeMenuIndex === uploaded_file_id) {
      this.setState({
        activeMenuIndex: '',
        isShowSbom: false,
      });
    } else {
      this.setState({
        activeMenuIndex: uploaded_file_id,
        isShowSbom: false,
      });
    }
  };

  setFileMove(obj, id) {
    this.setState({
      isMovingFile: true,
    }, () => {
      api.setFileMove({
        selected_project_id: obj.selectedProject.id,
        selected_project_version_id: obj.selectedProjectVersion.id,
      }, id)
        .then(() => {
          this.setState({
            isMovingFile: false,
            isOpenMFM: false,
          });
          this.props.updateFilePath(obj, id);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  setCompareItem() {
    this.props.setCompareItem(this.props.file);
  }

  generateToken = (length) => {
    let i = 0;
    let result = '';
    const timeStamp = new Date();
    const components = [
      timeStamp.getYear(),
      timeStamp.getMonth(),
      timeStamp.getDate(),
      timeStamp.getHours(),
      timeStamp.getMinutes(),
      timeStamp.getSeconds(),
      timeStamp.getMilliseconds(),
    ];
    const id = components.join('');
    const charactersLength = id.length;

    for (i; i < length; i++) {
      result += id.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  };

  abbreviateNumber(value) {
    let newValue = value;
    if (value >= 10000) {
      const suffixes = ['', 'K', 'M', 'B', 'T'];
      const suffixNum = Math.floor(` ${value}`.length / 4);
      let shortValue = '';
      let i = 4; //precision
      for (i; i >= 1; i--) {
        shortValue = parseFloat(
          (suffixNum !== 0 ? value / (1000 ** suffixNum) : value).toPrecision(i) // prettier-ignore
        ); // ** : Math.pow()
        const dotLessShortValue = `${shortValue} `.replace(/[^a-zA-Z 0-9]+/g, '');
        if (dotLessShortValue.length <= 4) {
          break;
        }
      }
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  }

  closeModal() {
    this.setState({
      isOpenMSI: false,
      isOpenMSU: false,
      isOpenAlertModal: false,
      isOpenMCX: false,
      isOpenMCD: false,
      isOpenMVX: false,
      isOpenMNA: false,
      isOpenMCB: false,
    });
  }

  closeExportModal() {
    this.setState({
      modalExportIsOpen: false,
      isDownloadingReport: false,
      toExport: '',
    });
  }

  closeMoveFileModal() {
    this.setState({
      isOpenMFM: false,
    });
  }

  refreshSecurityReport() {
    const { refreshSecurityReport, file } = this.props;
    refreshSecurityReport(file.uploaded_file_id);
  }

  downloadReport(exportFormat, exportType, toExport) {
    const { state, file, translate } = this.props;
    const { currentPrecisionLevel } = state.user;
    const token = this.generateToken(10);
    const downloadFormatMapping = {
      [REPORT_EXTENSION_CSV]: 'csv',
      [REPORT_EXTENSION_EXCEL]: 'xlsx',
      [REPORT_EXTENSION_JSON]: 'zip',
    };

    let type;
    let url;

    if (currentPrecisionLevel) {
      type = currentPrecisionLevel;
    } else {
      type = null;
    }

    if (type) {
      url = `/1/reports/${this.props.file.uploaded_file_id}/export?file_format=${exportFormat}&section=${exportType}&token=${token}&precision_level=${type}&export_to=${toExport}`;
    } else {
      url = `/1/reports/${this.props.file.uploaded_file_id}/export?file_format=${exportFormat}&section=${exportType}&token=${token}&export_to=${toExport}`;
    }

    this.setState({
      isDownloadingReport: true,
    });

    api
      .getExportedReport(url)
      .then((res) => {
        let data;
        let confidenceLevelName;
        const blob = new Blob([res], { type: 'application/octet-stream' });
        if (file.precisionLevel === 'narrow') {
          confidenceLevelName = 'high';
        } else if (file.precisionLevel === 'broad') {
          confidenceLevelName = 'low';
        } else {
          confidenceLevelName = file.precisionLevel;
        }
        const fileName = `${file.name}_${confidenceLevelName}.${downloadFormatMapping[exportFormat]}`;

        this.modalAction = translate('modal.title.notice');

        if (toExport === 's3') {
          data = JSON.parse(new TextDecoder().decode(res));
          const { bucket, key } = data.response;
          this.modalBody = translate('modal.message.export_send_s3');
          this.modalHeader = (
            <p className="modal_list" style={{ paddingTop: '10px' }}>
              <b>{translate('modal.title.bucket')}</b>
              &nbsp;
              {bucket}
            </p>
          );
          this.modalSubBody = (
            <p className="modal_list">
              <b>{translate('modal.title.file_storage_path')}</b>
              &nbsp;
              {key}
            </p>
          );
        } else if (toExport === 'email') {
          data = JSON.parse(new TextDecoder().decode(res));
          const { dest_email } = data.response;
          this.modalBody = translate('modal.message.export_send_email');
          this.modalHeader = translate('modal.message.export_send_to_email', { email: dest_email });
          this.modalSubBody = null;
        } else if (toExport === 'local') {
          FileSaver.saveAs(blob, fileName);
          this.modalBody = translate('modal.message.export_send_local');
          this.modalHeader = null;
          this.modalSubBody = null;
        }
        this.setState({
          isDownloadingReport: false,
          modalExportIsOpen: false,
          isOpenAlertModal: true,
          toExport,
        });
      })
      .catch((err) => {
        console.log(err);
        let jsonParse;
        const ArrayBufferView = Object.getPrototypeOf(Object.getPrototypeOf(new Uint8Array())).constructor;
        if (err.data instanceof ArrayBuffer || err.data instanceof ArrayBufferView) {
          jsonParse = JSON.parse(new TextDecoder().decode(err.data));
        } else {
          jsonParse = err.data;
        }
        const o = jsonParse.response;
        this.modalAction = translate('modal.title.attention');

        if (!o.error) {
          this.modalBody = translate('modal.error.unknow_error');
        }

        if (o.error === '422-002') { // recovery email
          this.modalBody = translate('modal.error.error_422_002_export');
        }

        if (o.error === '422-365') { // license expired
          this.modalBody = translate('system.message.license_expired');
        }

        if (o.error === '422-366') {
          this.modalBody = o.error_description;
        }

        if (o.error === '422-367') { // smtp error
          this.modalBody = translate('modal.error.error_422_368_jira');
        }

        if (o.error === '422-791') {
          this.modalBody = translate('modal.error.error_422_791_export');
        }

        this.modalHeader = null;
        this.modalSubBody = null;

        this.setState({
          isDownloadingReport: false,
          modalExportIsOpen: false,
          isOpenAlertModal: true,
        });

      });
  }

  deletedCallback() {
    this.props.deletedCallback();
  }

  renderScanStatus() {
    const { file } = this.props;
    const { scanStatusDetail } = file;
    return (
      <div>
        <Loader active size="large" />
        <div className="scan_detail">
          <h5 style={{ fontWeight: '500' }}>{scanStatusDetail}</h5>
        </div>
      </div>
    );
  }

  renderSecurityChart = (securityCount) => {
    const realData = securityCount;
    const dummyData = cloneDeep(realData);
    delete dummyData.total;

    const maxKey = Object.keys(dummyData).reduce((a, b) => {
      return dummyData[a] > dummyData[b] ? a : b;
    });

    const criticalRate = Math.round((dummyData.critical / dummyData[maxKey]) * 100);
    const highRate = Math.round((dummyData.high / dummyData[maxKey]) * 100);
    const mediumRate = Math.round((dummyData.medium / dummyData[maxKey]) * 100);
    const lowRate = Math.round((dummyData.low / dummyData[maxKey]) * 100);

    return (
      <div className="mini_bar_chart2 ">
        <div className="mini_bar_box small">
          <div className="value">
            {this.abbreviateNumber(securityCount.critical)}
          </div>
          <div
            className="mini_bar red"
            style={{
              height: `${criticalRate || 0}%`,
            }}
          />
        </div>
        <div className="mini_bar_box small">
          <div className="value">
            {this.abbreviateNumber(securityCount.high)}
          </div>
          <div
            className="mini_bar orange"
            style={{
              height: `${highRate || 0}%`,
            }}
          />
        </div>
        <div className="mini_bar_box small">
          <div className="value">
            {this.abbreviateNumber(securityCount.medium)}
          </div>
          <div
            className="mini_bar cheese"
            style={{
              height: `${mediumRate || 0}%`,
            }}
          />
        </div>
        <div className="mini_bar_box small">
          <div className="value">
            {this.abbreviateNumber(securityCount.low)}
          </div>
          <div
            className="mini_bar yellow"
            style={{
              height: `${lowRate || 0}%`,
            }}
          />
        </div>
      </div>
    );
  };

  renderTrendChart = () => {
    const { security_issue_count } = this.props.file;
    const maxKey = Object.keys(security_issue_count).reduce((a, b) => {
      return security_issue_count[a].total > security_issue_count[b].total ? a : b;
    });

    const undecidedRate = (security_issue_count.undecided.total / security_issue_count[maxKey].total).toFixed(2);
    const resolvedRate = (security_issue_count.resolved.total / security_issue_count[maxKey].total).toFixed(2);
    const disregardedRate = (security_issue_count.disregarded.total / security_issue_count[maxKey].total).toFixed(2);

    const undecidedRates = {
      critical: Math.round((security_issue_count.undecided.critical / security_issue_count.undecided.total) * 100) * undecidedRate,
      high: Math.round((security_issue_count.undecided.high / security_issue_count.undecided.total) * 100) * undecidedRate,
      medium: Math.round((security_issue_count.undecided.medium / security_issue_count.undecided.total) * 100) * undecidedRate,
      low: Math.round((security_issue_count.undecided.low / security_issue_count.undecided.total) * 100) * undecidedRate,
    };

    const resolvedRates = {
      critical: Math.round((security_issue_count.resolved.critical / security_issue_count.resolved.total) * 100) * resolvedRate,
      high: Math.round((security_issue_count.resolved.high / security_issue_count.resolved.total) * 100) * resolvedRate,
      medium: Math.round((security_issue_count.resolved.medium / security_issue_count.resolved.total) * 100) * resolvedRate,
      low: Math.round((security_issue_count.resolved.low / security_issue_count.resolved.total) * 100) * resolvedRate,
    };

    const disregardedRates = {
      critical: Math.round((security_issue_count.disregarded.critical / security_issue_count.disregarded.total) * 100) * disregardedRate,
      high: Math.round((security_issue_count.disregarded.high / security_issue_count.disregarded.total) * 100) * disregardedRate,
      medium: Math.round((security_issue_count.disregarded.medium / security_issue_count.disregarded.total) * 100) * disregardedRate,
      low: Math.round((security_issue_count.disregarded.low / security_issue_count.disregarded.total) * 100) * disregardedRate,
    };

    /*
      * critical
      * high
      * medium
      * low
     */
    return (
      <div className="mini_bar_chart2" style={{ position: 'relative' }}>
        {/**undecided */}
        <div className="mini_bar_box">
          <div className="value">{this.abbreviateNumber(security_issue_count.undecided.total)}</div>
          <div className="mini_bar yellow" style={{ height: `${undecidedRates.low}%`, position: 'absolute', top: `${100 - undecidedRates.critical - undecidedRates.high - undecidedRates.medium - undecidedRates.low}%` }} />
          <div className="mini_bar cheese" style={{ height: `${undecidedRates.medium}%`, position: 'absolute', top: `${100 - undecidedRates.critical - undecidedRates.high - undecidedRates.medium}%` }} />
          <div className="mini_bar orange" style={{ height: `${undecidedRates.high}%`, position: 'absolute', top: `${100 - undecidedRates.critical - undecidedRates.high}%` }} />
          <div className="mini_bar red" style={{ height: `${undecidedRates.critical}%`, position: 'absolute', top: `${100 - undecidedRates.critical}%` }} />
        </div>
        {/**resolved */}
        <div className="mini_bar_box ">
          <div className="value">{this.abbreviateNumber(security_issue_count.resolved.total)}</div>
          <div className="mini_bar yellow" style={{ height: `${resolvedRates.low}%`, position: 'absolute', top: `${100 - resolvedRates.critical - resolvedRates.high - resolvedRates.medium - resolvedRates.low}%` }} />
          <div className="mini_bar cheese" style={{ height: `${resolvedRates.medium}%`, position: 'absolute', top: `${100 - resolvedRates.critical - resolvedRates.high - resolvedRates.medium}%` }} />
          <div className="mini_bar orange" style={{ height: `${resolvedRates.high}%`, position: 'absolute', top: `${100 - resolvedRates.critical - resolvedRates.high}%` }} />
          <div className="mini_bar red" style={{ height: `${resolvedRates.critical}%`, position: 'absolute', top: `${100 - resolvedRates.critical}%` }} />
        </div>
        {/**disregarded */}
        <div className="mini_bar_box ">
          <div className="value">{this.abbreviateNumber(security_issue_count.disregarded.total)}</div>
          <div className="mini_bar yellow" style={{ height: `${disregardedRates.low}%`, position: 'absolute', top: `${100 - disregardedRates.critical - disregardedRates.high - disregardedRates.medium - disregardedRates.low}%` }} />
          <div className="mini_bar cheese" style={{ height: `${disregardedRates.medium}%`, position: 'absolute', top: `${100 - disregardedRates.critical - disregardedRates.high - disregardedRates.medium}%` }} />
          <div className="mini_bar orange" style={{ height: `${disregardedRates.high}%`, position: 'absolute', top: `${100 - disregardedRates.critical - disregardedRates.high}%` }} />
          <div className="mini_bar red" style={{ height: `${disregardedRates.critical}%`, position: 'absolute', top: `${100 - disregardedRates.critical}%` }} />
        </div>
      </div>
    );
  };

  render() {
    const iconStyle = {
      width: '14px',
      height: '14px',
      color: '#969696',
      fontWeight: 'bold',
      fontSize: '12px',
      marginRight: '5px',
    };

    const { translate, file, state } = this.props;
    const { has_leakage, use_scan_option, uploaded_file_id } = file;
    const {
      isSelectable,
      checkValues,
      isOpenAlertModal,
      toExport,
      isOpenMCX,
      isOpenMCD,
      isOpenMNA,
      isShowSbom,
      isOpenMVX,
      activeMenuIndex,
      isOpenMCB,
    } = this.state;

    const getItemStyle = (isDragging, draggableStyle) => {
      return {
        opacity: isDragging && 0.6,
        ...draggableStyle,
      };
    };

    return (
      <div
        className={cx('content_project_card_box', {
          version_group: this.props.file.project_version_name,
        })}
      >
        <div
          className={cx(
            'content_project_card',
            {
              select_mode: isSelectable,
            },
            {
              active: checkValues.indexOf(uploaded_file_id) > -1,
            },
            {
              more_menu_show: activeMenuIndex === uploaded_file_id
            }
          )}
          ref={this.props.draggableProvided.innerRef}
          {...this.props.draggableProvided.draggableProps}
          {...this.props.draggableProvided.dragHandleProps}
          style={getItemStyle(
            this.props.draggableSnapshot.isDragging,
            this.props.draggableProvided.draggableProps.style
          )}
          onClick={this.handleCheckChange}
        >
          <div className="content_project_card_inner">
            {
              checkValues.indexOf(uploaded_file_id) > -1
              && <span className="active_mode"><Icon name="check" /></span>
            }
            <div className="content_project_card_header">
              <div className="name">
                { use_scan_option ? (<img src={quickScan} alt="" />) : null}
                <span>{this.props.file.name}</span>
              </div>
              <div
                className="more"
                onClick={this.handleMoreMenu}
                onKeyUp={this.handleMoreMenu}
              >
                <a>
                  <img src={moreBtn} alt="more" />
                </a>
              </div>
              <div className="more_menu">
                {this.props.file.is_security_rescanned ? (
                  <p className="noti">
                    <a onClick={this.handleSecurityInfoItem} onKeyUp={this.handleSecurityInfoItem}>
                      <Icon name="info circle" />
                      {translate('card.menu.security_risk_updated')}
                    </a>
                  </p>
                ) : null}
                <ul>
                  <li>
                    <a onClick={this.handleInfoItem}>
                      <Icon name="info" style={{ color: '#969696' }} />
                      {translate('card.menu.information')}
                    </a>
                  </li>
                  {
                    has_leakage ? (
                      <li>
                        <a onClick={this.handleLeakageList}>
                          <Icon name="shield" style={{ color: '#969696' }} />
                          {translate('card.menu.leakage')}
                        </a>
                      </li>
                    ) : null
                  }
                  <li>
                    {
                      this.props.file.security_count.total > 0 ? (
                        <a onClick={this.setCompareItem}>
                          <img src={compareBtn} alt="" />
                          {translate('card.menu.compare')}
                        </a>
                      ) : (
                        <a
                          style={{
                            cursor: 'default',
                            opacity: '.45',
                            color: '#dddddd',
                          }}
                        >
                          <img src={compareBtn} alt="" />
                          {translate('card.menu.compare')}
                        </a>
                      )
                    }
                  </li>
                  <li>
                    {
                      this.props.file.has_manage_permission ? (
                        <a onClick={this.handleMove}>
                          <img src={moveFileIcon} alt="" />
                          {translate('card.menu.move')}
                        </a>
                      ) : (
                        <a
                          style={{
                            cursor: 'default',
                            opacity: '.45',
                            color: '#dddddd',
                          }}
                        >
                          <img src={moveFileIcon} alt="" />
                          {translate('card.menu.move')}
                        </a>
                      )
                    }
                  </li>
                  <li>
                    <a
                      onClick={(e) => {
                        return this.handleCardBookmarkChange(e, this.props.file.uploaded_file_id);
                      }}
                    >
                      {this.props.file.is_bookmark ? (
                        <Icon name="bookmark" style={iconStyle} />
                      ) : (
                        <Icon name="bookmark outline" style={iconStyle} />
                      )}
                      {translate('card.menu.bookmark')}
                    </a>
                  </li>
                  {
                    state.user.use_crypto ? (
                      <li>
                        <a
                          onClick={this.handleCBOM}
                          onKeyUp={this.handleCBOM}
                        >
                          <Icon name="download" style={iconStyle} />
                          CBOM
                        </a>
                      </li>
                    ) : null
                  }
                  <li>
                    <a
                      className="sbom"
                      onClick={this.handleSlideToggle}
                      onKeyUp={this.handleSlideToggle}
                    >
                      <img src={exportIcon} alt="" />
                      SBOM
                    </a>
                    <ul
                      className={cx(
                        'sub_menu',
                        {
                          active: isShowSbom,
                        },
                      )}
                    >
                      <li style={{ padding: '0 0 0 20px' }}>
                        <a
                          onClick={this.handleExport}
                          onKeyUp={this.handleExport}
                        >
                          <Icon name="download" style={iconStyle} />
                          {translate('card.menu.clarity')}
                        </a>
                      </li>
                      <li style={{ padding: '0 0 0 20px' }}>
                        <a
                          onClick={this.handleSpdx}
                          onKeyUp={this.handleSpdx}
                        >
                          <Icon name="download" style={iconStyle} />
                          {translate('card.menu.spdx')}
                        </a>
                      </li>
                      <li style={{ padding: '0 0 0 20px' }}>
                        <a
                          onClick={this.handleCycloneDx}
                          onKeyUp={this.handleCycloneDx}
                        >
                          <Icon name="download" style={iconStyle} />
                          CycloneDX
                        </a>
                      </li>
                      <li style={{ padding: '0 0 0 20px' }}>
                        <a
                          onClick={this.handleVexBom}
                          onKeyUp={this.handleVexBom}
                        >
                          <Icon name="download" style={iconStyle} />
                          VEX
                        </a>
                      </li>
                      <li style={{ padding: '0 0 0 20px' }}>
                        <a
                          onClick={this.handleNIASbom}
                          onKeyUp={this.handleNIASbom}
                        >
                          <Icon name="download" style={iconStyle} />
                          NIS
                        </a>
                      </li>
                    </ul>
                  </li>
                  {/**
                  <li>
                    <a onClick={this.refreshSecurityReport} onKeyUp={this.refreshSecurityReport}>
                      <Icon name="refresh" style={iconStyle} />
                      {translate('modal.new_scan.title.refresh_security')}
                    </a>
                  </li>
                  */}
                  <li>
                    {this.props.file.has_manage_permission ? (
                      <a onClick={this.handleDelete}>
                        <img src={deleteIcon} alt="" />
                        {translate('card.menu.delete')}
                      </a>
                    ) : (
                      <a
                        style={{
                          cursor: 'default',
                          backgroundColor: '#cccccc',
                        }}
                      >
                        <img src={deleteIcon} alt="" />
                        {translate('card.menu.delete')}
                      </a>
                    )}
                  </li>
                </ul>
              </div>
              <div
                className={cx('version', {
                  bookmark_version: this.props.file.project_version_name,
                })}
              >
                {this.props.file.project_version_name}
                <a
                  className="version_bookmark_button"
                  onClick={(e) => {
                    return this.handleCardVersionBookmarkChange(
                      e,
                      this.props.file.project_version_id
                    );
                  }}
                >
                  {this.props.file.project_version_is_bookmark ? (
                    <img src={activeBookmarkImg} alt="" className="active" />
                  ) : (
                    <img src={normalBookmarkImg} alt="" className="normal" />
                  )}
                </a>
              </div>
            </div>
            <div className="content_project_card_content">
              {
                file.scanStatus && file.scanStatus !== 2 ? (
                  this.renderScanStatus()
                ) : (
                  <div className="content_project_card_content_inner">
                    <div
                      className="card_content"
                      style={{ cursor: 'pointer' }}
                      onClick={this.handleClick}
                    >
                      <div className="card_content_item mini_bar_chart2_card">
                        <p className="title">{translate('panel.menu.security_risk')}</p>
                        <div className="value">
                          {this.abbreviateNumber(this.props.file.security_count.total)}
                          {this.props.file.has_exploit ? (<Icon name="bug" />) : null}
                        </div>
                        {this.renderSecurityChart(this.props.file.security_count)}
                      </div>
                      <div className="card_content_item mini_bar_chart2_card">
                        <p className="title">{translate('card.menu.security_issue_state')}</p>
                        {this.renderTrendChart()}
                      </div>
                    </div>
                  </div>
                )
              }
            </div>
            <div className="content_project_card_footer">
              <p className="time">{this.props.file.uploaded_at}</p>
              <p className="name">{this.props.file.owner}</p>
            </div>
          </div>
        </div>
        <DeleteModal
          isOpen={this.state.isOpen}
          closeModal={this.handleClose}
          rowData={this.props.file}
          deletedCallback={this.deletedCallback}
          translate={translate}
        />
        <ExportModal
          isOpenMED={this.state.modalExportIsOpen}
          onClose={this.closeExportModal}
          handleModal={this.downloadReport}
          isDownloading={this.state.isDownloadingReport}
          birdView
          rowData={this.props.file}
          translate={translate}
        />
        <MoveFileModal
          isOpenMFM={this.state.isOpenMFM}
          closeModal={this.closeMoveFileModal}
          rowData={this.state.movingData}
          isMovingFile={this.state.isMovingFile}
          setFileMove={this.setFileMove}
          projectName={this.props.projectName}
          translate={translate}
        />
        <ScanInfoModal
          isOpenMSI={this.state.isOpenMSI}
          reportId={this.props.file.uploaded_file_id}
          closeModal={this.closeModal}
          translate={translate}
        />
        <SecurityRiskUpdatedModal
          isOpenMSU={this.state.isOpenMSU}
          reportId={this.props.file.uploaded_file_id}
          closeModal={this.closeModal}
          translate={translate}
        />
        <SPDXDocumentGenerator
          isOpenMCX={isOpenMCX}
          reportId={file.uploaded_file_id}
          uploadedFileName={file.name}
          closeModal={this.closeModal}
          translate={translate}
        />
        <CycloneDXDocumentGenerator
          isOpenMCD={isOpenMCD}
          reportId={file.uploaded_file_id}
          closeModal={this.closeModal}
          translate={translate}
        />
        <VexGenerator
          isOpenMVX={isOpenMVX}
          reportId={file.uploaded_file_id}
          closeModal={this.closeModal}
          translate={translate}
        />
        <CBOMGenerator
          isOpenMCB={isOpenMCB}
          reportId={file.uploaded_file_id}
          fileName={file.name}
          closeModal={this.closeModal}
          translate={translate}
        />
        <NISModal
          isOpenMNA={isOpenMNA}
          reportId={file.uploaded_file_id}
          translate={translate}
          closeModal={this.closeModal}
        />
        <Modal open={isOpenAlertModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                {
                  toExport === 's3' ? (
                    <Modal.Description>
                      <Header>
                        {this.modalBody}
                      </Header>
                      {this.modalHeader}
                      {this.modalSubBody}
                    </Modal.Description>
                  ) : (
                    <Modal.Description>
                      <Header>
                        {this.modalBody}
                      </Header>
                      <p className="modal_list">{this.modalHeader}</p>
                      <p>{this.modalSubBody}</p>
                    </Modal.Description>
                  )
                }

                <div className="button_wrap">
                  <a className="center_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
SecurityProjectCard.defaultProps = {
  file: {},
};

export default inject('state')(observer(SecurityProjectCard));
